export default __webpack_public_path__ + "static/media/texi.c652e355.svg";